import React, { useEffect, useState } from 'react';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import {
  PERFORMANCE_MONITORING,
  PERFORMANCE_MONITORING_SEARCH_RESULTS,
  PERFORMANCE_MONITORING_SEARCH_RESULTS_CONFLICT_DETAILS,
} from '../../../routes/routeConstants';
import ConflictDetails from './ConflictDetails';
import ReportList from './ReportList';

const PerformanceMonitoringSearchResultsConflictDetails = () => {
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Performance Monitoring`,
        link: `/${PERFORMANCE_MONITORING}`,
      },
      {
        name: `Results for NIN: 67848393983`,
        link: `/${PERFORMANCE_MONITORING_SEARCH_RESULTS}`,
      },
      {
        name: `Rainbow Bay Crafts Report`,
        link: `/${PERFORMANCE_MONITORING_SEARCH_RESULTS_CONFLICT_DETAILS}`,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Driver History Conflict Details'>
      <PageLayout>
        <BreadCrumbs pathData={pathArr as any} />
        <Container>
          <ConflictDetails />
          <ReportList />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default PerformanceMonitoringSearchResultsConflictDetails;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
